import React, { useState } from "react";
import { Grid, Modal } from "@mui/material";
import { Icon } from "@iconify/react";
import IconButton from "@mui/material/IconButton";
import { AntSwitch } from "../../../components/antSwitch";
import { useNavigate } from "react-router-dom";
import DeleteModal from "./deleteModal";
import StatusModal from "./statusModal";

export default function UserTypeCoulmn(props) {
  const navigate = useNavigate();
  const { setAlert, setOpenAlert, setResponseMsg, setLoading, getUserTypeData } = props;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const ALERT_DURATION = 2000;

  const alertClose = () => {
    setAlert('')
  }
  const handleOpenDeleteModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenDeleteModal(true);
  };

  const handleOpenStatusModal = (id, status) => {
    setSelectedId(id);
    setSelectedStatus(status);
    setOpenStatusModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const handleCloseStatusModal = () => {
    setOpenStatusModal(false);
  };

  const userTypeColumn = [
    // {
    //   field: "id",
    //   headerName: "ID",
    // },
    {
      field: "typeName",
      headerName: "User Type",
      flex: 1,
      renderCell: (params) => (
        <Grid onClick={() => navigate(`/userTypeView/${params.row.id}?type=edit`)}>
          <span style={{ color: "darkblue", cursor: "pointer" }}>{params.value}</span>
        </Grid>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      renderCell: (params) => {
        const htmlString = params.value || "";
        const plainText = htmlString.replace(/<[^>]+>/g, '').replace(/\n/g, ' ');
        return (
          <div>
            {plainText}
          </div>
        );
      },
    },
    {
      field: "countryId",
      headerName: "Country",
      flex: 1,
      renderCell: (params) => {
        return (
          <Grid>
            <span>{params?.row?.country?.name}</span>
          </Grid>
        )
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <>
          <div style={{ paddingTop: 15 }}>
            <AntSwitch checked={params.row.status === "ACTIVE"} onChange={() => handleOpenStatusModal(params.row.id, params.row.status)} inputProps={{ "aria-label": "controlled" }} />
          </div>

          <Modal open={openStatusModal} onClose={handleCloseStatusModal} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
            <StatusModal onClose={handleCloseStatusModal} getUserTypeData={getUserTypeData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
          </Modal>
        </>
      ),
    },

    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          <Grid>
            <IconButton aria-label="edit" size="small">
              <img src="/assets/editIcon.svg" alt="District" width="16" height="16" onClick={() => navigate(`/addUserType/${params.row.id}?type=edit`)} />
            </IconButton>

            <IconButton aria-label="delete" size="small" onClick={() => handleOpenDeleteModal(params.row.id, params.row.status)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="red" d="M7.5 1h9v3H22v2h-2.029l-.5 17H4.529l-.5-17H2V4h5.5zm2 3h5V3h-5zM6.03 6l.441 15h11.058l.441-15zM13 8v11h-2V8z" /></svg>
            </IconButton>
          </Grid>

          <Modal open={openDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ sx: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}>
            <DeleteModal onClose={handleCloseDeleteModal} getUserTypeData={getUserTypeData} selectedId={selectedId} selectedStatus={selectedStatus} alertClose={alertClose} setOpenAlert={setOpenAlert} setResponseMsg={setResponseMsg} setAlert={setAlert} ALERT_DURATION={ALERT_DURATION} setLoading={setLoading} />
          </Modal>
        </>
      ),
    },
  ];

  return userTypeColumn;
}
